import React, { useCallback, useMemo, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { ReadOutlined } from '@ant-design/icons'
import { Button, Table, Tooltip } from 'antd'

import { isMac } from '../../../core/utils'

import { StyledHotkeyModal } from '../../../common/components/styled'
import { COMMON_AVAILABLE_HOTKEYS } from '../../../common/constants'

import { LOCATIONS_AVAILABLE_HOTKEYS } from '../../constants'

const LocationsHotkeysLegend = () => {
  const [isVisible, setIsVisible] = useState(false)

  const tableData = useMemo(
    () => [
      COMMON_AVAILABLE_HOTKEYS.L,
      COMMON_AVAILABLE_HOTKEYS.UP,
      COMMON_AVAILABLE_HOTKEYS.DOWN,
      COMMON_AVAILABLE_HOTKEYS.LEFT,
      COMMON_AVAILABLE_HOTKEYS.RIGHT,
      COMMON_AVAILABLE_HOTKEYS.SHIFT_DOWN,
      COMMON_AVAILABLE_HOTKEYS.SHIFT_UP,
      COMMON_AVAILABLE_HOTKEYS.SHIFT_LEFT,
      COMMON_AVAILABLE_HOTKEYS.SHIFT_RIGHT,
      LOCATIONS_AVAILABLE_HOTKEYS.S,
      LOCATIONS_AVAILABLE_HOTKEYS.SHIFT_S,
      LOCATIONS_AVAILABLE_HOTKEYS.ENTER,
      LOCATIONS_AVAILABLE_HOTKEYS.ESC,
      LOCATIONS_AVAILABLE_HOTKEYS.R,
      LOCATIONS_AVAILABLE_HOTKEYS.SHIFT_R,
      ...(isMac()
        ? [
            COMMON_AVAILABLE_HOTKEYS.CMD_LEFT,
            COMMON_AVAILABLE_HOTKEYS.CMD_RIGHT,
          ]
        : [
            COMMON_AVAILABLE_HOTKEYS.CTRL_LEFT,
            COMMON_AVAILABLE_HOTKEYS.CTRL_RIGHT,
          ]),
    ],

    [],
  )

  const popoverContent = useMemo(() => {
    const columns = [
      {
        title: 'Key',
        dataIndex: 'hotkey',
        key: 'hotkey',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
    ]

    return (
      <Table
        dataSource={tableData}
        columns={columns}
        size="small"
        pagination={false}
      />
    )
  }, [tableData])

  const handleCancel = useCallback(() => setIsVisible(false), [])
  const toggleModal = useCallback(() => setIsVisible(!isVisible), [isVisible])

  useHotkeys(COMMON_AVAILABLE_HOTKEYS.L.hotkey, toggleModal, [toggleModal])

  return (
    <>
      <StyledHotkeyModal
        title="Location list navigation hotkeys"
        footer={null}
        visible={isVisible}
        wrapClassName="dishes-list-hotkeys-legend"
        onCancel={handleCancel}
      >
        {popoverContent}
      </StyledHotkeyModal>
      <Tooltip title="Location list navigation hotkeys">
        <Button icon={<ReadOutlined />} shape="circle" onClick={toggleModal} />
      </Tooltip>
    </>
  )
}

export default LocationsHotkeysLegend
